export const formatOrgContactLine = ({ orgName, orgPhone, orgEmail }) => {
	const parts = [];
	if (orgPhone) {
		parts.push(orgPhone);
	}
	if (orgEmail) {
		parts.push(orgEmail);
	}
	if (parts.length === 0) {
		return null;
	}
	const contact = parts.join(' or ');
	if (orgName) {
		return `Questions? Contact ${orgName} at ${contact}.`;
	}
	return `Questions? Contact us at ${contact}.`;
};
